import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const invoiceotherinfoApi = createApi({
  reducerPath: "invoiceotherinfoApi",
  baseQuery,
  tagTypes: ["invoiceOtherInfo"],
  endpoints: (builder) => ({
    // 🔹 Get all invoices by masterId
    getInvoiceOtherinfoByMasterId: builder.query({
      query: ({id,subId}) => `export/invoice/otherinfo/${id}/${subId}`,
      transformResponse: (response) => response?.data ?? [],
      providesTags: ["invoiceOtherInfo"],
    }),

    // 🔹 Get single invoice by Id
    getInvoiceOtherinfoById: builder.query({
      query: ({ id, subId }) =>
        `export/invoice/otherinfo/${id}/${subId}`,
      transformResponse: (response) => response?.data ?? null,
      providesTags: ["invoiceOtherInfo"],
    }),
    

    // 🔹 Create new invoiceBuyer
    createInvoiceOtherinfo: builder.mutation({ // ✅ spelling corrected
      query: ({ id, dataId , ...data  }) => ({
        url: `export/invoice/otherinfo/${id}/${dataId}`,
        method: "PUT",
        body: { otherInfo:data },
        headers: {
          "X-Request-Id":`${Date.now()}`,
        },
      }),
      invalidatesTags: ["invoiceOtherInfo"],
    }),
    

    // 🔹 Update invoiceBuyer by Id
    updateInvoiceOtherinfo: builder.mutation({
      query: ({id, dataId , ...data  }) => ({
        url: `export/invoice/otherinfo/${id}/${dataId}`,
        method: "PUT", // ✅ should be PUT, not GET
        body: { otherInfo:data},
        headers: {
          "X-Request-Id":`${Date.now()}`,
        },
      }),
      invalidatesTags: ["invoiceOtherInfo"],
    }),

  }),
});

export const {
  useGetInvoiceOtherinfoByMasterIdQuery,
  useLazyGetInvoiceOtherinfoByIdQuery,
  useCreateInvoiceOtherinfoMutation,
  useUpdateInvoiceOtherinfoMutation,
} = invoiceotherinfoApi;
